"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import UiForm from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import { CloumnListModel } from "@/models/tableModels/Tablecolumn.model";
import Sortable from "sortablejs";
import API from "@ym-framework/api-utils";
import _ from "lodash";
let DisplayTeamList = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.ColumnList = new CloumnListModel();
    this.waiting = false;
    this.list_loading = false;
    this.confirm = _.debounce(() => __async(this, null, function* () {
      this.ConfirmRight();
    }), 800);
  }
  open() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(
          `api://base.auth/api/v8/columns`,
          {
            params: {
              type: "team"
            }
          }
        );
        this.ColumnList = response.data;
        this.dialog.visible = true;
      } catch (error) {
      }
    });
  }
  sortable() {
    return __async(this, null, function* () {
      try {
        const el = document.querySelector(".checked-card-main");
        const _this = this;
        Sortable.create(el, {
          filter: ".unchecked",
          onStart: function() {
            _this.waiting = true;
          },
          onEnd: _.debounce((_0) => __async(this, [_0], function* ({ newIndex, oldIndex }) {
            _this.list_loading = true;
            const currRow = _this.ColumnList.columns.splice(oldIndex, 1)[0];
            _this.ColumnList.columns.splice(newIndex, 0, currRow);
            yield new Promise((resolve, reject) => {
              let timer = setTimeout(() => {
                resolve(true);
              }, 1e3);
            });
            _this.list_loading = false;
            _this.waiting = false;
          }), 800)
        });
      } catch (error) {
        console.log(error);
      }
    });
  }
  cancel() {
    this.dialog.visible = false;
  }
  ConfirmRight() {
    return __async(this, null, function* () {
      try {
        console.log(this.ColumnList);
        yield API.post(`api://base.auth/api/v8/columns`, {
          type: "team",
          columns: this.ColumnList.columns
        });
        this.dialog.visible = false;
        this.$emit("refresh");
      } catch (error) {
        console.log(error);
      }
    });
  }
};
DisplayTeamList = __decorateClass([
  Component({
    components: {
      UiForm,
      UiSubmit,
      UiDialog
    }
  })
], DisplayTeamList);
export {
  DisplayTeamList as default
};
